import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { forwardRef } from 'react';
import { companyNumber } from '../../Constants';
import { contactEmail, appLogo } from './Constants';

const Footer = forwardRef((props, ref) => {
    return (
        <footer ref={ref} className='bg-landing-slate-950 text-landing-slate-400 py-16 border-t border-landing-slate-900'>
            <div className='max-w-7xl mx-auto px-6'>
                {/* Main Footer Content */}
                <div className='grid md:grid-cols-4 gap-12 mb-12'>
                    {/* Brand Section */}
                    <div className='md:col-span-2'>
                        <div className='mb-6 inline-block'>
                            <div className='bg-landing-white rounded-full p-3 inline-block'>
                                <img 
                                    src={appLogo} 
                                    alt='Quyva' 
                                    className='h-10 w-10 object-contain'
                                />
                            </div>
                        </div>
                        <p className='text-landing-slate-400 mb-6 max-w-md leading-relaxed'>
                            AI-Powered Enterprise Platform that enables organizations to engage with their data — 
                            documents, images, and databases — using natural language.
                        </p>
                        <div className='space-y-3'>
                            <p className='text-landing-white font-semibold mb-3'>Contact Us</p>
                            {companyNumber && (
                                <div className='flex items-center gap-3'>
                                    <FontAwesomeIcon icon={faPhone} className='text-landing-blue-400 w-4' />
                                    <a href={`tel:${companyNumber}`} className='hover:text-landing-white transition'>
                                        {companyNumber}
                                    </a>
                                </div>
                            )}
                            <div className='flex items-center gap-3'>
                                <FontAwesomeIcon icon={faEnvelope} className='text-landing-blue-400 w-4' />
                                <a href={`mailto:${contactEmail}`} className='hover:text-landing-white transition'>
                                    {contactEmail}
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Company Links */}
                    <div>
                        <p className='text-landing-white font-semibold mb-6'>Company</p>
                        <ul className='space-y-3'>
                            <li>
                                <a href='/' className='hover:text-landing-white transition'>Home</a>
                            </li>
                            <li>
                                <a href='/contactUs' className='hover:text-landing-white transition'>Contact Us</a>
                            </li>
                        </ul>
                    </div>

                    {/* Legal Links */}
                    <div>
                        <p className='text-landing-white font-semibold mb-6'>Legal</p>
                        <ul className='space-y-3'>
                            <li>
                                <a href='/terms-and-conditions' className='hover:text-landing-white transition'>
                                    Terms & Conditions
                                </a>
                            </li>
                            <li>
                                <a href='/privacy-policy' className='hover:text-landing-white transition'>
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <a href='/brand-guidelines' className='hover:text-landing-white transition'>
                                    Brand Guidelines
                                </a>
                            </li>
                            <li>
                                <a href='/refund-and-cancellations' className='hover:text-landing-white transition'>
                                    Refund Policy
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className='pt-8 border-t border-landing-slate-800 flex flex-col md:flex-row justify-between items-center gap-4'>
                    <div className='text-sm'>
                        <span className='text-landing-white'>&copy; {new Date().getFullYear()} MTree Software Pvt. Ltd.</span>
                        <span className='text-landing-slate-500'> All rights reserved.</span>
                    </div>
                    <div className='flex items-center gap-6'>
                        <a href='https://in.linkedin.com/company/mtree-software-pvt.-ltd' target='_blank' rel='noopener noreferrer' className='text-landing-slate-400 hover:text-landing-white transition'>
                            <FontAwesomeIcon icon={faLinkedinIn} className='text-lg' />
                        </a>
                        <a href='https://www.mtree.co.in' target='_blank' rel='noopener noreferrer' className='text-landing-slate-400 hover:text-landing-white transition text-sm'>
                            MTree Software
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
});

export default Footer;
